/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Org_UsedInputs */

const cs_billing_org_used = /** @type {(inputs: Billing_Org_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyčerpaná firemní alokace`)
};

const en_billing_org_used = /** @type {(inputs: Billing_Org_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Org allocation used`)
};

/**
* | output |
* | --- |
* | "Org allocation used" |
*
* @param {Billing_Org_UsedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_org_used = /** @type {((inputs?: Billing_Org_UsedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Org_UsedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_org_used(inputs)
	return cs_billing_org_used(inputs)
});